import { useState, useEffect } from 'react';
import { Fetch } from '../utils/Utils.js';

// The account's finance currency (account.settings.currency: BRL or USD).
export const currencySymbolFor = (currency) => {
  if (currency === 'USD') return '$';
  return 'R$';
};

// useCurrencySymbol loads the account's currency symbol, R$ until loaded —
// for finance pages outside the Finances hub (e.g. a project's detail page).
export const useCurrencySymbol = () => {
  const [currency, setCurrency] = useState('BRL');
  useEffect(() => {
    Fetch('api/data/account.settings', 'GET', null,
      (data) => {
        const settings = Array.isArray(data) ? data[0] : data;
        if (settings?.currency) setCurrency(settings.currency);
      },
      () => {}
    );
  }, []);
  return currencySymbolFor(currency);
};

// formatBalance shows a signed balance the way the finance list shows
// amounts: "+R$1200.00", "-R$800.00", "R$0.00".
export const formatBalance = (amount, symbol) => {
  const n = Number(amount || 0);
  const sign = n > 0 ? '+' : n < 0 ? '-' : '';
  return `${sign}${symbol}${Math.abs(n).toFixed(2)}`;
};

// balanceClass colors a balance: positive green, negative red, zero neutral.
export const balanceClass = (amount) =>
  amount > 0 ? 'project-balance positive' : amount < 0 ? 'project-balance negative' : 'project-balance';
